import { RouterProvider, createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";
import Login from "./pages/login/index";
import BasePage from "pages/base";
import ProtectedRoute from "components/ProtectedRoute";
import NotFoundPage from "pages/notFound";
import EducatorBase from "pages/educatorBase";
import AIHelperGetStarted from "pages/base/AIHelperTool/AIHelperGetStarted";
import { useSelector } from "react-redux";
import AIHelperSkillsReview from "pages/base/AIHelperTool/AIHelperSkillsReview";
import AIHelperSubskillsReview from "pages/base/AIHelperTool/AIHelperSubskillsReview";
import AIHelperShareFeedback from "pages/base/AIHelperTool/AIHelperShareFeedback";

import store from "redux/store";
import educatorService from "services/educatorService";
import { setArtifactDetailsRedux } from "redux/slices/artifactDetails/artifactDetailsSlice";
import { setAssociatedSkillsRedux } from "redux/slices/associatedSkills/associatedSkillsSlice";

const RootLayout = () => {
  const location = useLocation();
  const isArtifactReviewRoute = location.pathname.startsWith("/artifact-review");
  
  return (
    <div className={`h-screen min-w-[968px] ${!isArtifactReviewRoute ? "overflow-hidden" : ""}`}>
      <Outlet />
    </div>
  );
};

const AppDisplay = () => {
  const { id, role } = useSelector((state: any) => state.account);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      errorElement: <NotFoundPage />,
      children: [
        {
          path: "/",
          element: (
            <>
              {role == "ROLE_LEARNER" ? (
                <Navigate to="/base" replace />
              ) : (
                <Navigate to="/educator" replace />
              )}
            </>
          ),
        },
        { path: "/login", element: <Login /> },
        {
          path: "/base",
          element: (
            <ProtectedRoute>
              {role === "ROLE_LEARNER" || role == "ROLE_EDUCATOR" ? <BasePage /> : <NotFoundPage />}
            </ProtectedRoute>
          ),
        },
        {
          path: "/educator",
          element: (
            <ProtectedRoute>
              {role === "ROLE_EDUCATOR" ? <EducatorBase /> : <NotFoundPage />}
            </ProtectedRoute>
          ),
        },
        {
          path: "/artifact-review",
          // loader: async () => {
          //   const artifactDetailsRedux = store.getState().artifactDetails.data;
          //   const associatedSkillsRedux = store.getState().associatedSkills.data;
          //   console.log("artifactDetailsRedux in appDisplay", artifactDetailsRedux);

          //   const hydrateArtifactDetails = async () => {
          //     const artifactId = sessionStorage.getItem("artifactId");
          //     const hasArtifactIdChanged = artifactId && artifactDetailsRedux?.id && String(artifactDetailsRedux.id) !== String(artifactId);

          //     if (!artifactDetailsRedux || !artifactDetailsRedux.areas || hasArtifactIdChanged) {
          //       if (artifactId) {
          //         try {
          //           const artifactDetailsResponse = await educatorService.getEvidenceDetails(artifactId);
          //           const cachedAreaSelectionsStr = sessionStorage.getItem("selectedAreas");
          //           const cachedAreaSelections = cachedAreaSelectionsStr ? JSON.parse(cachedAreaSelectionsStr) : null;

          //           let updatedState = {
          //             ...artifactDetailsRedux,
          //             ...artifactDetailsResponse,
          //           };

          //           if (cachedAreaSelections) {
          //             updatedState = {
          //               ...updatedState,
          //               areas: cachedAreaSelections,
          //             }
          //           }

          //           store.dispatch(setArtifactDetailsRedux(updatedState));
          //         } catch (error) {
          //           console.error("Error fetching artifact details in router loader function ", error)
          //         }
          //       }        
          //     }
          //   }

          //   const hydrateAssociatedSkills = async () => {
          //     const schoolId = sessionStorage.getItem("schoolId");
          //     if (schoolId) {

          //     }
          //     if (!associatedSkillsRedux || !associatedSkillsRedux.areas) {
          //       try {
          //         const associatedSkillsResponse = await educatorService.fetchAssociatedSkills(schoolId as string);

          //         store.dispatch(setAssociatedSkillsRedux({
          //           ...associatedSkillsRedux,
          //           ...associatedSkillsResponse,
          //         }))
          //       } catch (error) {
          //         console.error("Error fetching associated skills in router loader function ", error)
          //       }
          //     }
          //   }

          //   await Promise.all([
          //     hydrateArtifactDetails(),
          //     hydrateAssociatedSkills(),
          //   ])

          //   return null;
          // },
          children: [        
            {
              path: "get-started",
              element: (
                <AIHelperGetStarted />
              ),
            },
            {
              path: "skills-review",
              element: (
                <AIHelperSkillsReview />
              ),
            },
            {
              path: "subskills-review",
              element: (
                <AIHelperSubskillsReview />
              ),
            },
            {
              path: "share-feedback",
              element: (
                <AIHelperShareFeedback />
              ),
            }
          ]
        },
      ]
    },
  ]);
  return (
    <RouterProvider router={router} />
  );
};

export default AppDisplay;
